export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'Home',
    icon: 'fa-regular fa-house',
    link: '/',
  },
];
export const MENU_SETTINGS_ITEMS: MenuItem[] = [
  {
    title: 'COMPANY PROFILE',
    link: '/company-profile',
    icon: 'pantone-outline',
    id: 'manageCompanyProfile',
  },
  {
    title: 'USERS',
    link: '/users',
    icon: 'people-outline',
    id: 'manageGuards',
  },
  {
    title: 'JOB TYPES',
    link: '/job-types',
    icon: 'layers-outline',
    id: 'manageGroupedJobTypes',
  },
  // {
  //   title: 'INCIDENT TYPES',
  //   link: '/incident-type',
  //   icon: 'layers-outline',
  //   id: 'manageIncidentTypes',
  // },
  // {
  //   title: 'MONITORING COMPANIES',
  //   link: '/monitoring-company',
  //   icon: 'shield-outline',
  //   id: 'manageMCompanies',
  // },
  // {
  //   title: 'RESPONSE TYPES',
  //   link: '/response-type',
  //   icon: 'layers-outline',
  //   id: 'manageResponseTypes',
  // },
  // {
  //   title: 'SERVICE TYPES',
  //   link: '/service-type',
  //   icon: 'layers-outline',
  //   id: 'manageServiceTypes',
  // },
  {
    title: 'MOBILE FORMS',
    link: '/mobile-forms',
    icon: 'layers-outline',
    id: 'manageUserPrompts',
  },
  {
    title: 'INVOICING',
    link: '/invoice-jobs',
    icon: 'layers-outline',
    id: 'manageInvoiceJobs',
  },
  {
    title: 'SUBCONTRACTORS',
    link: '/sub-contractors',
    icon: 'layers-outline',
    id: 'manageSubContractors',
  },
];

export const SUPER_USER_MENU_ITEMS: MenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'fa-regular fa-house',
    link: '/gtadmin/dashboard',
  },
  {
    title: 'Support',
    icon: 'message-square-outline',
    link: '/gtadmin/support',
  },
  {
    title: 'Subscribers',
    icon: 'people-outline',
    link: '/gtadmin/subscribers',
  },
  {
    title: 'App Users',
    icon: 'person-done-outline',
    link: '/gtadmin/app-users',
  },
  // {
  //   title: 'Beta Users',
  //   icon: 'people-outline',
  //   link: '/gtadmin/beta-users',
  // },
  {
    title: 'Releases',
    icon: 'code-download-outline',
    link: '/gtadmin/releases',
  },

  {
    title: 'Subscription Plans',
    icon: 'cube-outline',
    link: '/gtadmin/subscription-plans',
  },

  {
    title: 'App Routes',
    icon: 'options-outline',
    link: '/gtadmin/app-routes',
  },
  {
    title: 'Job Status',
    icon: 'save-outline',
    link: '/gtadmin/job-status',
  },
  {
    title: 'Job Types',
    icon: 'save-outline',
    link: '/gtadmin/job-type',
  },
  {
    title: 'Misc',
    icon: 'person-done-outline',
    link: '/gtadmin/misc',
  },
];

export const appUserMenu: MenuItem[] = [
  { title: 'Edit Profile', icon: 'fas fa-user', link: '/profile' },

  {
    title: 'Subscription',
    link: '/subscription',
    icon: 'fas fa-user',
  },
  { title: 'Support', link: '/support', icon: 'fas fa-user' },
  { title: 'Change Log', icon: ' ', link: 'updateApp' },
  // { title: 'Change Account', icon: '', link: 'changeAccount' },
];

export const superUserMenu: MenuItem[] = [
  { title: 'Edit Profile', icon: ' ', link: '/gtadmin/profile' },
  { title: 'Change Log', icon: ' ', link: 'updateApp' },
  { title: 'Sign Out', icon: ' ', link: 'signOut' },
];

export interface MenuItem {
  title: string;
  link: string;
  icon: string;
  id?: string;
}
